export default "__VITE_ASSET__LbjqXT5e__"